import { t } from '../messages';

/**
 * « 1,4 Mo », « 312 ko », « 940 octets » — une taille lisible, en français, jamais un nombre
 * d'octets nu sous les yeux d'un enseignant.
 *
 * **Dans son propre fichier, et pas à côté des composants qui l'utilisent.** Un module qui exporte
 * à la fois des composants React et autre chose casse le rafraîchissement à chaud de Vite : le
 * message est explicite (« Could not Fast Refresh — "formatFileSize" export is incompatible ») et
 * la conséquence est que TOUT l'écran se remonte à chaque frappe, en perdant son état. Constaté le
 * 8 septembre 2026 sur `DocumentList.tsx`, d'où ce fichier.
 */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return t('documents.sizeBytes', { n: bytes });
  if (bytes < 1024 * 1024) return t('documents.sizeKb', { n: Math.round(bytes / 1024) });
  const mb = bytes / (1024 * 1024);
  const rounded = mb >= 10 ? Math.round(mb) : Math.round(mb * 10) / 10;
  return t('documents.sizeMb', { n: String(rounded).replace('.', ',') });
}
